const Users = () => import('./Users.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Users,
  path: '/usuarios',
  meta: {
    label: 'Usuários'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'usersList',
      meta: {
        label: 'Gerenciar Usuários',
        requiredPermission: {resource: 'user', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'userCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'user', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'userEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'user', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/users/routes.js